import Image from 'next/image';
import { iconList } from './data';

const SectionConnect = () => {
  return (
    <section className="flex justify-center items-center flex-col md:items-start">
      <div className="w-[130px] h-10">
        <img
          width="130"
          height="40"
          src="https://d2o2utebsixu4k.cloudfront.net/ug-logo.svg"
        />
      </div>
      <div className="flex items-center mt-[35px] md:mt-[45px] gap-x-[25px]">
        {iconList.map((ele, index) => {
          return (
            <div className=" cursor-pointer" key={index}>
              <a href={ele.href} target={'_blank'} rel="noreferrer">
                <i className={`${ele.icon} footer-icons inline-block`}></i>
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
};
export default SectionConnect;
